export const KAHVE_AHMET = [
  {
    id: "ka001",
    metin: "{{ad}}, fincanına baktım. {{soru}} konusunda net söyleyeyim: hayat çizgin güçlü ama kararlılık eksik. Karar ver, uygula, sonucu gör. Ertelenen her karar zamanla daha ağır bir yük haline gelir.\n\nHareketsiz kalmak da bir seçimdir — ama genellikle en pahalı olanı. Adım at. Doğru mu yanlış mı, sonra anlarsın. Ama hiç atmamak her zaman yanlıştır.",
    tema: "karar"
  },
  {
    id: "ka002",
    metin: "{{ad}}, akıl çizgin derin ve uzun. Zekân var, bunu görüyorum. {{soru}} için şunu söyleyeyim: o zekâyı tam kullanmıyorsun. Ya çok hızlı karar veriyorsun ya da aşırı düşünerek felç oluyorsun.\n\nDüşün, analiz et — ama bir sınır koy. Mükemmel plan yoktur, iyi uygulama vardır. Sahaya çık, masa başında değil sahada öğrenilir.",
    tema: "zeka"
  },
  {
    id: "ka003",
    metin: "{{ad}}, baş parmağın sert. İnatçısın. {{soru}} konusunda inatçılık bazen erdem, bazen engel — ikisi arasındaki fark çok ince.\n\nİnat ilkelerinde durduğunda erdeme dönüşür. Ama hata yaptığında geri adım atmayı reddediyorsan, bu güç değil zayıflık. Kendine sor: bu inat benim için mi, yoksa bir şeyi kanıtlamak için mi?",
    tema: "inat"
  },
  {
    id: "ka004",
    metin: "{{ad}}, hayat çizginde bir kırılma var. Bir değişim geçirdin ya da geçireceksin. {{soru}} için bu değişime direnmek enerji kaybıdır.\n\nKabul et ve ilerle. Değişim seni yok etmek için gelmiyor — dönüştürmek için. En sağlam çelikler en yüksek ısıda şekillenir. Bu kırılma senin için de böyle bir fırsat.",
    tema: "degisim"
  },
  {
    id: "ka005",
    metin: "{{ad}}, fincan bana bir kapı gösteriyor. Açık. {{soru}} için beklediğin fırsat orada duruyor — ama sen bakıyorsun da göremiyorsun.\n\nGözünü aç. Fırsatlar her zaman parlak bir tabela taşımaz. Bazen sıradan görünen bir konuşma, sıradan görünen bir gün — içinde büyük kapılar saklı. Dikkatli ol.",
    tema: "firsat"
  },
  {
    id: "ka006",
    metin: "{{ad}}, fincanının sol tarafı ağır. Geçmişin yükü bu. {{soru}} konusunda ilerliyemiyorsan sebebi orada.\n\nO yükü bırak. Taşımak zorunda değilsin. Geçmiş seni şekillendirdi ama tanımlamak zorunda değil. Bugün bir karar ver: o yükü bırakıyorum — ve ilerleyebiliyorum.",
    tema: "gecmis"
  },
  {
    id: "ka007",
    metin: "{{ad}}, fincan bana iş ve emek gösteriyor. {{soru}} konusunda kestirme yol arama. Emek ver, karşılığını alırsın.\n\nKısa yollar uzun acılara çıkar — bunu kırk yılda öğrendim. Sağlam iş yavaş gider ama kalıcı olur. Emekle inşa edilen şeyler, şansla gelenden çok daha dayanıklıdır.",
    tema: "emek"
  },
  {
    id: "ka008",
    metin: "{{ad}}, fincanında bir kırılma noktası var. {{soru}} meselesinde bir karar vermek zorundasın — ertelemek çözüm değil.\n\nErteledikçe ağırlaşıyor. Her geçen gün o karar daha zor hale geliyor. Bugün ver — doğru mu yanlış mı zamanla anlarsın. Ama ver.",
    tema: "karar"
  },
  {
    id: "ka009",
    metin: "{{ad}}, fincan bana sağlık mesajı veriyor. {{soru}} ne olursa olsun, önce bedenine bak. Yorulmuşsun — hem bedenin hem zihni.\n\nDinlenmeyen beden, zihni de çalıştıramaz. Uyku düzenine dikkat et, bu dönem. Küçük sorunlar zamanında ele alındığında küçük kalır. Kendinle ilgilen.",
    tema: "saglik"
  },
  {
    id: "ka010",
    metin: "{{ad}}, fincanın kenarında bir çıkış işareti var. {{soru}} konusunda içinde bulunduğun durumdan çıkış yolu görünüyor — ama cesaret ister.\n\nCesaret yokluğu durumun değil, korkuya rağmen adım atmaktır. O adımı atmaya hazır mısın? Hazır olmayı bekleme — hazırlık hareket içinde gelir.",
    tema: "cikis"
  },
  {
    id: "ka011",
    metin: "{{ad}}, fincan bana güven meselesinden söz ediyor. {{soru}} için etrafındaki herkese güvenmek zorunda değilsin.\n\nAz ve öz. Seçici ol. Güveni herkese aynı şekilde dağıtmak seni açık hale getirir. Kim gerçekten yanında, kim sadece iyi günlerde? Bu ayrımı yap.",
    tema: "guven"
  },
  {
    id: "ka012",
    metin: "{{ad}}, fincanında bir yükseliş var — yavaş ama istikrarlı. {{soru}} konusunda hızlı sonuç bekleme.\n\nİstikrarlı adım atan, sonunda zirveye çıkar. Hızlı yükselen hızlı düşer — sağlam yükselen kalır. Sen sağlam yükseliyorsun. Devam et.",
    tema: "yukselis"
  },
  {
    id: "ka013",
    metin: "{{ad}}, fincan bana bir kayıp gösteriyor. Ama bu kayıp seni küçültmüyor — büyütüyor. {{soru}} konusunda kaybettiğin şey, belki tutman gerekmeyendi zaten.\n\nHer kapanan kapı, açılması gereken bir kapıya işaret eder. Kaybı yas tutarak geç — ama orada kalma. İlerisi var.",
    tema: "kayip"
  },
  {
    id: "ka014",
    metin: "{{ad}}, fincan bana çok konuşan ama az yapan insanlar gösteriyor etrafında. {{soru}} için söz değil, iş lazım.\n\nSözü bırak, eyleme geç. Eylem içinde netleşir, masa başında değil. Bugün küçük bir adım at — büyük planlar yerine küçük eylemler.",
    tema: "eylem"
  },
  {
    id: "ka015",
    metin: "{{ad}}, fincanında bir bekleyiş var. {{soru}} konusunda sabretmek zorundasın — ama boş oturarak değil, hazırlanarak bekle.\n\nFırsat geldiğinde hazır ol. Bekleme dönemleri boşa geçmez — doğru kullanılırsa güçlenme dönemleridir. Beklerken hazırlan.",
    tema: "bekleme"
  },
  {
    id: "ka016",
    metin: "{{ad}}, fincan bana aile ve yakın çevreden söz ediyor. {{soru}} ne olursa olsun, yakınlarınla köprüleri yıkma.\n\nEn zor anda en yakın insanlar yanında olur. Belki şu an aramızda bir mesafe var — ama o bağı koparmak, kopmaya değmez. Bir adım at.",
    tema: "aile"
  },
  {
    id: "ka017",
    metin: "{{ad}}, fincanının dibinde berrak bir alan var. Bu netlik işareti. {{soru}} konusunda kafan karışık görünse de içinde cevabı biliyorsun.\n\nKendini dinle. Dışarıdan cevap arama — içeride zaten var. O iç sesi bastıran gürültüyü sustur. Sessizlikte cevap bulunur.",
    tema: "netlik"
  },
  {
    id: "ka018",
    metin: "{{ad}}, fincan bana bir rekabet ortamı gösteriyor. {{soru}} konusunda rekabete giriyorsun.\n\nRakibini küçümseme ama kendini de küçümseme. Adil kazan. En iyi rekabet, kendini geçmektir — başkasını değil. Dünden daha iyi ol, yeterli bu.",
    tema: "rekabet"
  },
  {
    id: "ka019",
    metin: "{{ad}}, fincanında bir dönüm noktası var. {{soru}} için şunu söyleyeyim: bu karar hayatının seyrini değiştirebilir.\n\nHafife alma. Ağır otur, kalkar — bu sadece bir söz değil. Büyük kararlar acele verilmez, ama sonsuza da ertelenmez. Düşün, danış, karar ver.",
    tema: "donum_noktasi"
  },
  {
    id: "ka020",
    metin: "{{ad}}, fincan bana uzak bir yolculuktan söz ediyor. {{soru}} konusunda ufkunu genişletmen gerekiyor.\n\nDar düşünme. Alışılmış çevrenden çık — fiziksel ya da zihinsel. Yeni bir ortam, yeni bir bakış açısı, yeni bir insan. Ufuk genişledikçe seçenekler çoğalır.",
    tema: "yolculuk"
  },
  {
    id: "ka021",
    metin: "{{ad}}, fincanında güç var — kullanılmamış, bekleyen bir güç. {{soru}} konusunda kapasiteni küçümsüyorsun.\n\nYapabilirsin — ama inanman lazım önce. Kendine olan inancın, dışarıdan gelen her destekten daha güçlüdür. O inancı bul. İçinde zaten var.",
    tema: "guc"
  },
  {
    id: "ka022",
    metin: "{{ad}}, fincan bana bir anlaşmazlıktan söz ediyor. {{soru}} konusunda bir çatışma var ya da olacak.\n\nHaklı olsan bile sesi yükseltme. Sakin kazanırsın. Öfkeyle yapılan konuşmalar genellikle pişmanlıkla biter. Soğukken konuş — etkisi çok daha güçlü olur.",
    tema: "catisma"
  },
  {
    id: "ka023",
    metin: "{{ad}}, fincanında bir yenilik işareti var. {{soru}} için yeni bir başlangıç kapıda.\n\nEski alışkanlıkları bırakmaya hazır ol. Yeni dönem, yeni yaklaşım ister. Aynı şeyleri yaparak farklı sonuçlar beklemek en bilinen yanılgıdır. Farklı dene.",
    tema: "yenilik"
  },
  {
    id: "ka024",
    metin: "{{ad}}, fincan bana şunu söylüyor: çok şey taşıyorsun. {{soru}} konusunda her şeyi tek başına çözmeye çalışıyorsun.\n\nYardım istemek zayıflık değil — akıllılık. En güçlü insanlar yardım ister. Çünkü tek başına yapılabilecekler sınırlı, birlikte yapılabilecekler sınırsız.",
    tema: "yardim"
  },
  {
    id: "ka025",
    metin: "{{ad}}, fincanın genel olarak iyi. {{soru}} konusunda endişenin büyük kısmı gereksiz — kafanda büyüttüğün sorunlar gerçekte o kadar büyük değil.\n\nBir adım geri çekil ve bak. Çoğu sorun yakından büyük, uzaktan küçük görünür. O mesafeyi al, perspektifi değiştir. Rahat ol — üstesinden geleceksin.",
    tema: "genel"
  }
];